// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_LedgerResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Staff-family admin ledger response — cost fields allowed.
 * Full-gated only.
 */
import type { AiCredits_LedgerRow } from './AiCredits_LedgerRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_LedgerResponseDados {
franquia_id: number
rows: AiCredits_LedgerRow[]
}

export type AiCredits_LedgerResponse = ApiResponse<AiCredits_LedgerResponseDados>;

registerResponseContract('AiCredits_LedgerResponse', {
  franquia_id: { type: 'number',  required: true },
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                  { type: 'number',  required: true },
      franquia_id:         { type: 'number',  required: true },
      franchise_name:      { type: 'string',  required: false },
      entry_type:          { type: 'string',  required: true },
      signed_micro:        { type: 'number',  required: true },
      balance_after_micro: { type: 'number',  required: true },
      request_id:          { type: 'string',  required: true },
      pricing_id:          { type: 'number',  required: false },
      pricing_source:      { type: 'string',  required: false },
      meta:                { type: 'string',  required: false },
      created_at:          { type: 'string',  required: false },
    },
  },
})
